import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_apnblrf5vf: FaireBrandEntity = {
  token: "b_apnblrf5vf",
  type: "brand",
  name: "UWP Luxe",
  avatarUrl:
    "https://cdn.faire.com/fastly/651d52015c13789283c4540ec88ee23f34ab551528509d473a253fae9fd8773e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/be17eee90a67a5940f58f5622a94fabf17fcedca6eb65997d13e802d2a8d1926.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/651d52015c13789283c4540ec88ee23f34ab551528509d473a253fae9fd8773e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/be17eee90a67a5940f58f5622a94fabf17fcedca6eb65997d13e802d2a8d1926.jpeg",
  location: "Mason, OH, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 87,
  isTopShop: true,
  isInsider: true,
  description:
    'Paper is often taken for granted. It is used for the most basic and mundane tasks, yet even the simplest piece of paper has the potential to become something beautiful.\n\nUWP Luxe is a boutique line of pop-up greeting cards and laser-cut stationery. We believe that paper, the humblest of mediums, holds so much potential. We hope the integrity of our beliefs shines through in all of our products, from elaborately foiled pop-ups to dainty details printed onto envelope flaps.  We have been recognized by the Greeting Card Association\'s Louie Awards with the coveted "Card of the Year" in both 2018 & 2019 and won the 2021 Louie Award for Paper Engineering & Innovation.\n\nOur creative team is housed in New Haven, CT inside a charming converted factory building; our loft is nestled amongst tinkerers and thinkers of all sorts. Our corporate headquarters are located in the office of Up With Paper, Mason, OH. We love what we do at UWP Luxe, and we thank you for letting us share our craft with you.\n\nxo,\n\nThe UWP Luxe Team',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:20.408Z",
    importedBy: "entity-db-cli",
  },
};
